import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

interface Props {
  /** A lucide icon component (24×24 by default, we render at 36). */
  icon: LucideIcon;
  /** Single-line headline. */
  title: string;
  /** One-sentence explanation of why the state is empty. */
  hint?: string;
  /** Optional CTA button — primary action to recover from the empty state. */
  cta?: ReactNode;
}

/** Standardized empty state — icon + title + hint + CTA. Replaces the
 *  bare-text "No active events" / "No plan items" placeholders. */
export function EmptyState({ icon: Icon, title, hint, cta }: Props) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-10 px-6 rounded-xl border border-dashed border-mono-700/60 bg-mono-900/30">
      <Icon className="h-9 w-9 text-mono-500 mb-3" strokeWidth={1.5} />
      <p className="text-mono-100 font-medium">{title}</p>
      {hint && <p className="text-mono-400 text-sm mt-1.5 max-w-xs">{hint}</p>}
      {cta && <div className="mt-4">{cta}</div>}
    </div>
  );
}
